
import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TicketsSection from '@/components/TicketsSection';
import PageHeader from '@/components/PageHeader';
import LogoScroller from '@/components/LogoScroller';

const Tickets = () => {
  return (
    <div className="min-h-screen bg-ai-dark">
      <Helmet>
        <title>Tickets - AI World Congress 2026 - November 25-26, London UK - AI Conference</title>
        <meta name="description" content="Book your tickets for AI World Congress 2026 in London. Early Bird £495, VIP £695, Full Price £2,295. November 25-26 at The Great Hall, Kensington." />
        <link rel="canonical" href="https://aiconference.london/register" />
        <meta property="og:title" content="Tickets - AI World Congress 2026 - November 25-26, London UK - AI Conference" />
        <meta property="og:description" content="Book your tickets for AI World Congress 2026. Early Bird, VIP, and Full Price options available." />
        <meta property="og:url" content="https://aiconference.london/register" />
        <meta property="og:image" content="https://aiconference.london/lovable-uploads/og-banner-2026.jpg" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tickets - AI World Congress 2026 - November 25-26, London UK - AI Conference" />
        <meta name="twitter:description" content="Book your tickets for AI World Congress 2026 in London." />
        <meta name="twitter:image" content="https://aiconference.london/lovable-uploads/og-banner-2026.jpg" />
      </Helmet>
      
      <Header />
      <PageHeader
        title=""
        subtitle=""
        backgroundImage="/lovable-uploads/530fddbf-4fea-4198-860f-8165d2f8b445.png"
      />
      
      <div className="relative z-10 -mt-16">
        <TicketsSection standalone={true} />
      </div>
      <LogoScroller />
      <Footer />
    </div>
  );
};

export default Tickets;
